export default {
    APPLICATION_PDF:'application/pdf',
    APPLICATION_X_MSEXCEL:'application/x-msexcel'
}
